import * as React from "react";
import {StoreControl, StoreControlProps, StoreControlState} from "../../base/StoreControl";
import {ControlBaseProps} from "../../base/ControlBase";
import {CSSProperties} from "react";
import {$mobx} from "mobx";
import ReactSelect, {Async} from "react-select";
import './style.css'
import {ReactUtilities} from "../../../utilities/react/ReactUtilities";
import {ValidatorBase} from "../../../utilities/validator/ValidatorBase";
import {PropertyValidator} from "../../../utilities/validator/PropertyValidator";
import {StoreBase} from "../../../utilities/Store/StoreBase";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faSpinner} from "@fortawesome/free-solid-svg-icons/faSpinner";
library.add(faSpinner);
declare let cx:any;

const LoadingMessage = (props) => {
    let {cx,...rest}=props;
    return (
        <div style={props.getStyles('loadingMessage', props)}>
            {props.children}
            <span> </span>
            <FontAwesomeIcon style={{marginLeft:2}} icon={'spinner'} spin/>
        </div>
    );
};


export class DynamicSearchableSelect<S extends StoreBase=null> extends StoreControl<DynamicSearchableSelectProp<S>, SearchableSelectState> {
    static defaultProps: Partial<DynamicSearchableSelectProp<any>> = {
        isMulti:false,
        disabled:false
    };
    public combo;
    public styles;
    constructor(props: DynamicSearchableSelectProp<S>, context?: any) {
        super(props, context);
        this.state={
            IsValid:true,
            ErrorMessage:'',
            selectedValue:this.props.defaultValue
        };


        this.styles={
            menuPortal: styles => ({ ...styles, zIndex: 1000001 }),
        };
    }



    public render() {
        return (

            <div className={'rncontrol '+(this.state.IsValid?'':'has-errors')} style={this.props.style}>
                <label style={{width: '100%'}}>{this.props.Label}</label>
                <Async value={this.state.selectedValue} noOptionsMessage={()=>this.props.noOptionsMessage} placeholder={this.props.placeholder} loadingMessage={()=>this.props.loadingMessage} components={{LoadingMessage}}
                       cacheOptions defaultOptions loadOptions={this.props.promise} isDisabled={this.props.disabled} styles={this.styles}   menuPosition={'absolute'} menuPortalTarget={document.body} className={'rnSelect'} isSearchable={true}  isMulti={this.props.isMulti}
                       onChange={(e: any) => {
                           (this.props.isMulti?this.SetValue(e.map(x=>x.value),e) :this.SetValue(e.value, e.item));this.setState({selectedValue:{...e.item}})
                }}/>
                {this.GetValidationSection()}
            </div>

        )
    }

    GetValidators(): ValidatorBase[] {
        return [
            new PropertyValidator(this.props,"Required",()=>{return  this.GetNumericValue()>0},"Required field")
        ];
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
export interface DynamicSearchableSelectProp<S extends StoreBase> extends StoreControlProps<S>{
    style?:CSSProperties;
    Label:string;
    isMulti?:boolean;
    disabled?:boolean;
    promise:(inputValue:string)=>Promise<DynamicOptions[]>;
    loadingMessage?:string;
    placeholder?:string;
    noOptionsMessage?:string;
    onChange:(any)=>void;
    defaultValue:{label:string,value:string};

}

export interface DynamicOptions{
    label:string;
    value:string;
}

interface SearchableSelectState  extends StoreControlState{
    selectedValue:{label:string,value:string}
}

//#endregion "My Region"

